'use strict';
define([], function () {
    var MONTHS = {
        JA: 1, JAN: 1, JANUARY: 1,
        FE: 2, FEV: 2, FEB: 2, FEBRUARY: 2,
        MA: 3, MAR: 3, MARCH: 3,
        AP: 4, APR: 4, AVR: 4, APRIL: 4,
        MAG: 5, MY: 5, MAY: 5,
        GI: 6, GIU: 6, JU: 6, JUN: 6, JUNE: 6,
        LU: 7, LUG: 7, JUL: 7, JULY: 7,
        AG: 8, AGO: 8, AU: 8, AUG: 8, AUGUST: 8,
        SE: 9, SET: 9, SEP: 9, SEPTEMBER: 9,
        OC: 10, OTT: 10, OCT: 10, OCTOBER: 10,
        NO: 11, NOV: 11, NOVEMBER: 11,
        DE: 12, DIC: 12, DEC: 12, DECEMBER: 12
    };

    function pad(value) {
        return String(value).padStart(2, '0');
    }

    function monthNumber(name) {
        var key = String(name || '').toUpperCase();
        return MONTHS[key] || MONTHS[key.slice(0, 3)];
    }

    function normalizedDate(value) {
        var date = String(value || '').trim();
        var compact = date.match(/^(\d{4})(\d{2})$/);
        if (compact) {
            return compact[1] + '-' + compact[2] + '-01';
        }
        var yearMonth = date.match(/^(\d{4})[-/.](\d{1,2})/);
        if (yearMonth) {
            return yearMonth[1] + '-' + pad(yearMonth[2]) + '-01';
        }
        var monthYear = date.match(/^(\d{1,2})[-/.](\d{4})$/);
        if (monthYear) {
            return monthYear[2] + '-' + pad(monthYear[1]) + '-01';
        }
        var localized = date.match(/^(\d{4})[-\s]([A-Za-zÀ-ÿ]+)$/);
        if (localized) {
            var month = monthNumber(localized[2]);
            return month ? localized[1] + '-' + pad(month) + '-01' : date;
        }
        var localizedReverse = date.match(/^([A-Za-zÀ-ÿ]+)[-\s](\d{4})$/);
        if (localizedReverse) {
            var reverseMonth = monthNumber(localizedReverse[1]);
            return reverseMonth ? localizedReverse[2] + '-' + pad(reverseMonth) + '-01' : date;
        }
        return date;
    }

    function label(value) {
        var date = normalizedDate(value);
        var monthYear = date.match(/^(\d{4})-(\d{2})/);
        return monthYear ? monthYear[2] + '/' + monthYear[1].slice(2) : String(value || '');
    }

    function volumeOf(value) {
        var volume = value && typeof value === 'object'
            ? (value.volume !== undefined ? value.volume : value.searches)
            : value;
        return Number(volume) || 0;
    }

    function seriesFrom(history) {
        var values = history;
        if (typeof values === 'string') {
            try {
                values = JSON.parse(values);
            } catch (error) {
                return [];
            }
        }
        if (Array.isArray(values)) {
            return values.map(function (item, index) {
                return {
                    date: item && (item.timestamp || item.date || item.month || item.period),
                    volume: volumeOf(item),
                    order: index
                };
            });
        }
        if (!values || typeof values !== 'object') {
            return [];
        }
        return Object.keys(values).sort().map(function (date, index) {
            return {
                date: date,
                volume: volumeOf(values[date]),
                order: index
            };
        });
    }

    function hasValues(value) {
        if (!value) {
            return false;
        }
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        return typeof value !== 'object' || Object.keys(value).length > 0;
    }

    return function (input) {
        var history = input;
        if (input && typeof input === 'object' && !Array.isArray(input) &&
            (input.history !== undefined || input.detections !== undefined ||
                input.keyword !== undefined || input.keywordUuid !== undefined)) {
            history = hasValues(input.history) ? input.history : input.detections;
        }
        var series = seriesFrom(history).filter(function (item) {
            return !!item.date;
        }).sort(function (left, right) {
            return normalizedDate(left.date).localeCompare(normalizedDate(right.date))
                || left.order - right.order;
        }).slice(-12);
        var max = series.reduce(function (highest, item) {
            return Math.max(highest, item.volume || 0);
        }, 0);

        return series.map(function (item) {
            return {
                label: label(item.date),
                searches: item.volume,
                isPeak: max > 0 && item.volume === max,
                height: max > 0 ? Math.max(Math.round((item.volume / max) * 100), 4) : 4
            };
        });
    };
});
